/* tslint:disable: no-import-side-effect no-submodule-imports */

/* eslint-disable import/no-unassigned-import */
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.repeat';
import 'core-js/modules/es.string.starts-with';
import 'core-js/modules/es.string.ends-with';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.array.from';
import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.find-index';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.promise';
import 'core-js/modules/es.set';
import 'core-js/modules/es.map';
import 'core-js/modules/es.symbol';
import '@my/spletnik';
import '@my/myworld-ui-kit/dist/components/Icon/icons/index.js';
/* eslint-enable import/no-unassigned-import */

import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'mobx-react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { IConfig, DEFAULT_CONFIG, setConfig, setLocales } from '@constants';

import { Log } from '@utils';

import { getState, resetState, parseInitialState } from '@stores';

import { Api } from '@api';
import { BrowserHttpTransport } from '@api/BrowserHttpTransport';

import { App } from './App';

// eslint-disable-next-line import/no-unassigned-import
import './styles/common.scss';

resetState();
parseInitialState();
const stores = getState();

const root = document.getElementById('root');
const isEmptyRoot = !root || !root.innerHTML || String(root.innerHTML).length === 0;
let CONFIG: IConfig = DEFAULT_CONFIG;

try {
	CONFIG = JSON.parse(document.getElementById('app-config').innerHTML);

	setConfig(CONFIG);
} catch (err) {
	Log.error('FAILED PARSE APP CONFIG');
}

try {
	setLocales(JSON.parse(document.getElementById('app-locales').innerHTML));
} catch (err) {
	Log.error('FAILED PARSE APP LOCALES');
}

BrowserHttpTransport.setup();
Api.setTransport(BrowserHttpTransport);

const renderApp = async () => {
	if (!stores.currentUserStore?.currentUser?.id) {
		await stores.currentUserStore.fetchCurrentUser();
	}

	const tree = (
		<Provider
			{...stores}
		>
			<BrowserRouter>
				<App/>
			</BrowserRouter>
		</Provider>
	);

	if (isEmptyRoot) {
		createRoot(root).render(tree);
	} else {
		hydrateRoot(root, tree);
	}
};

const initApp = async () => {
	if (CONFIG.isServerRendering || CONFIG.isError502) {
		await renderApp();
	} else {
		try {
			/* render app */
			await renderApp();
		} catch (err) {
			Log.error('FAILED FETCH CURRENT USER');
			Log.message('Clear localStorage');

			await renderApp();
		}
	}
};

void initApp();
